var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-bg-blue",style:({backgroundImage: 'url('+ _vm.BgBlueImg +')',..._vm.blueStype})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }